// FIXME : hotfix for ingenico failure on spain 30/08/2020
export const postnetIcon = 'icon-posnet';
export const alternativeCash = 'Datafono';
export const PREFIX_BUTTON = 'checkout-payment-method';
